import { motion } from 'framer-motion';
import { TbAlertOctagonFilled } from 'react-icons/tb';
import { sectionAnimVariants } from '../../constants/animationVariants';

const AcademiaNotFound = ({ message }: { message: string }) => {
  // rendering custom not found component here
  return (
    <motion.div
      variants={sectionAnimVariants}
      initial='initial'
      animate='animate'
      className='flex items-center justify-center'
    >
      <div className='flex items-center justify-center gap-2 px-8 py-4 rounded-xl border-2 border-base-red bg-base-white text-base-red text-lg capitalize'>
        <TbAlertOctagonFilled className='size-6' />
        <p>Opps!! {message}</p>
      </div>
    </motion.div>
  );
};

export default AcademiaNotFound;
